/**************************************************************************************************************************************************
*   MODULE NAME     :  Audit
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  19-04-2021
*   DESCRIPTION     :  Component to load Audit page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
/**************************************************************************************************************************************************/

import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Tabs,
  Tab,
  Button,
  OverlayTrigger,
  Tooltip,
  InputGroup,
  Popover,
} from "react-bootstrap";
import {
  FaSpinner,
  FaTrashAlt,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDivide,
} from "react-icons/fa";
import {
  loadAllProduct,
  loadAllCountry,
  loadAllExplanation,
  loadAllStatus,
} from "../../actions/abstractActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import DataTable from "../common/dataTable/DataTable";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import { Component } from "react";
import { exportPDF } from "../common/ExportToPDF";
import AbstractApi from "../../api/AbstractApi";
import "./Audit.css";

class Audit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      auditData: [],
      statusMapper: {},
      productMapper: {},
      explanationMapper: {},
      productMapper: {},
      currentData: [],
      productList: this.props.productData,
      statusList: this.props.statusData,
      explanationList: this.props.explanationData,
      countryList: this.props.countryData,
      abstractId: this.props.match.params.abstractId,
    };
  }

  removeInverted = (s) => {
    if (!s || s.length === 0) return s;
    if (s[0] === '"') s = s.substr(1);
    if (s[s.length - 1] === '"') s = s.slice(0, -1);
    return s;
  }
  exportFile(dataList, colMapper) {

    var headers = [["Date/Time", "System Id", "Operation", "Field Name", "Old Value", "New Value"]];
    var widths = [50, 50, 50, 70, 265, 265]
    var colsExcluded = ["title", "authors", "abstract", "original_title", "keywords", "source", "institution", "url_to_ovid","case_ids"];
    dataList.sort((a, b) => (a["updatedAt"] < b["updatedAt"]) ? 1 : -1)
    const data = dataList.map(row => {
      let element = [];
      let updatedAt = row["updatedAt"] ? ddmmmyyyyFormat(row["updatedAt"],true) : " ";
      let updatedBy = row.updatedBy ? row.updatedBy : row && row.createdBy ? row.createdBy : ""
      let field = colMapper[row.field] ? colMapper[row.field].text : "";
      let fld = `${row.field}`;
      let oldF = (row.oldValue === "null" || !colMapper[row.field]) || (colsExcluded.indexOf(fld) !== -1) ? (fld.includes("date") && row.oldValue && row.oldValue !=="null"?ddmmmyyyyFormat(row.oldValue):row.oldValue) : colMapper[row.field].formatter(row.oldValue, { [row.field]: row.oldValue });

      let newF = (row.newValue === "null" || !colMapper[row.field]) || (colsExcluded.indexOf(fld) !== -1) ? (fld.includes("date") && row.newValue && row.newValue !== "null"?ddmmmyyyyFormat(row.newValue):row.newValue) : colMapper[row.field].formatter(row.newValue, { [row.field]: row.newValue });
      element.push(updatedAt);
      element.push(updatedBy);
      element.push(row.action);
      element.push(field);
      element.push(oldF);
      element.push(newF);
      return element;
    }
    )
    exportPDF("Audit Trail", "", headers, data, widths, "")
  }
  async componentDidMount() {
    this.setLoader(true);
    try {
      await Promise.all([this.loadAllCountry(), this.loadAllProduct(), this.loadAllStatus(), this.loadAllExplanation()])
    } catch (e) {
      this.setLoader(false);
    }
    AbstractApi.loadAbstractAudit(this.state.abstractId).then((data) => {
      if (data && data.data && data.data.result) {
        let auditData = data.data.result;
        auditData = auditData.map(row => {
          row.oldValue = this.removeInverted(row.oldValue);
          row.newValue = this.removeInverted(row.newValue);
          if (row.oldValue === "null" || row.oldValue === "" || !row.oldValue) {
            row.oldValue = "null";
          }
          if (row.newValue === "null" || row.newValue === "" || !row.newValue) {
            row.newValue = "null";
          }
          return row;
        })
        this.setState({
          auditData: auditData,
        });
      }
      this.setLoader(false);
    }).catch(e => {
      this.setLoader(false);
    });
  }
  formatMasterData = (data) => {
    let mapper = {};
    data.forEach((e) => {
      mapper[e.masterDataId] = e.masterDataValue;
    });
    return mapper;
  };
  loadAllProduct = async () => {
    let arr = this.state.productList;
    if (!(this.state.productList && this.state.productList.length > 0)) {
      let response = await this.props.loadAllProduct();
      arr = response.data.result
    }
    let productMapper = this.formatMasterData(arr);
    this.setState({
      productMapper,
    });
  };

  loadAllCountry = async () => {
    let arr = this.state.countryList;
    if (!(this.state.countryList && this.state.countryList.length > 0)) {
      let response = await this.props.loadAllCountry();
      arr = response.data.result
    }
    let countryMapper = this.formatMasterData(arr);
    this.setState({
      countryMapper,
    });
  };

  loadAllExplanation = async () => {
    let arr = this.state.explanationList;
    if (!(this.state.explanationList && this.state.explanationList.length > 0)) {
      let response = await this.props.loadAllExplanation();
      arr = response.data.result
    }
    let explanationMapper = this.formatMasterData(arr);
    this.setState({
      explanationMapper,
    });
  };

  loadAllStatus = async () => {
    let arr = this.state.statusList;
    if (!(this.state.statusList && this.state.statusList.length > 0)) {
      let response = await this.props.loadAllStatus();
      arr = response.data.result
    }
    let statusMapper = this.formatMasterData(arr);
    this.setState({
      statusMapper,
    });
  };

  setLoader = (isLoading) => this.setState({ isLoading });
  openAbstractDetailWindow = () => {
    window.open(`/abstractDetail/${this.state.abstractId}`, "", `width=${window.innerWidth},height=${window.innerHeight}`);
  }
  handleBackFunction = () => {
    window.close();
  };
  render() {
    let { auditData, isLoading, productMapper, statusMapper, explanationMapper, countryMapper, currentData } = this.state;
    let mappers = [
      {
        dataField: "title",
        text: "Title",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-basic">
                   <Popover.Content>{row.title}</Popover.Content>
                </Popover>
              }
            >
              <span>
                {row.title && row.title.length <= 145
                  ? row.title
                  : row.title && row.title.substr(0, 145) + "..."}
              </span>
            </OverlayTrigger>
          );
          return row.title ? _popOver : "";
        },
      },
      {
        dataField: "authors",
        text: "Author(s)",

        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.authors}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.authors&& row.authors.length <= 25
                  ? row.authors
                  : row.authors && row.authors.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.authors ? _popOver : "";
        },
      },
      {
        dataField: "product_id",
        text: "Product",
        formatter: (cellContent, row) => {
          return productMapper && row.product_id ? productMapper[row.product_id] : ""
        },
      },
      {
        dataField: "status_id",
        text: "Status",
        formatter: (cellContent, row) => {
          return statusMapper && row.status_id ? statusMapper[row.status_id] : ""
        },
      },
      {
        dataField: "country_id",
        text: "Country",
        formatter: (cellContent, row) => {
          return countryMapper && row.country_id ? countryMapper[row.country_id] : ""
        },
      },
      {
        dataField: "explanation_id",
        text: "Explanation",
        formatter: (cellContent, row) => {
          return explanationMapper && row.explanation_id ? explanationMapper[row.explanation_id] : ""
        },
      },
      {
        dataField: "other_status",
        text: "Other Status",
      },
      {
        dataField: "received_from",
        text: "Received From",
      },
      {
        dataField: "original_title",
        text: "Original Title",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.original_title}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.original_title.length <= 25
                  ? row.original_title
                  : row.original_title.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.original_title ? _popOver : "";
        },
      },
      {
        dataField: "site_processing_document",
        text: "Site of Processing",
        style: { textAlign: "left" },
      },
      {
        dataField: "document_site_origin",
        text: "Site of Origin",
      },
      {
        dataField: "abstract",
        text: "Abstract",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.abstract}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.abstract.length <= 25
                  ? row.abstract
                  : row.abstract.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.abstract ? _popOver : "";
        },
      },
      {
        dataField: "keywords",
        text: "Keywords",
        formatter: (cellContent, row) => {
          let commaSeperated = row.keywords.split("\\n").join(',')
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{commaSeperated}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {commaSeperated.length <= 25
                  ? commaSeperated
                  : commaSeperated.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return commaSeperated ? _popOver : "";
        },
      },
      {
        dataField: "source_xml_id",
        text: "Source XML ID"
      },
      {
        dataField: "source",
        text: "Source",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.source}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.source.length <= 25
                  ? row.source
                  : row.source.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.source ? _popOver : "";
        },
      },
      {
        dataField: "institution",
        text: "Institution",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.institution}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.institution.length <= 25
                  ? row.institution
                  : row.institution.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.institution ? _popOver : "";
        },
      },
      {
        dataField: "url_to_ovid",
        text: "URL To Ovid",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.url_to_ovid}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.url_to_ovid.length <= 25
                  ? row.url_to_ovid
                  : row.url_to_ovid.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.url_to_ovid ? _popOver : "";
        },
      },
      {
        dataField: "url_to_source_db",
        text: "URL To Source DB",
      },
      {
        dataField: "notes",
        text: "Notes",
      },
      {
        dataField: "abstract_language",
        text: "Abstract Language",
      },
      {
        dataField: "case_manager_id_1",
        text: "Abstract Record Screener",
      },
      {
        dataField: "case_manager_id_2",
        text: "Full Text Screener",
      },
      {
        dataField: "case_manager_id_3",
        text: "Record Closer",
      },
      {
        dataField: "migrate_flag",
        text: "Migrate Flag",
        formatter: (cellContent, row) => {
          return +cellContent ? "true" : "false";
        }
      },
      {
        dataField: "status_flag",
        text: "Status Flag",
        formatter: (cellContent, row) => {
          return +cellContent ? "true" : "false";
        }
      },
      {
        dataField: "enbl_alrts_and_vldtins_flag",
        text: "Alerts Flag",
        formatter: (cellContent, row) => {
          return +cellContent ? "true" : "false";
        }
      },
      {
        dataField: "original_abstract_id",
        text: "Orignal Abstract"
      },
      {
        dataField: "lockedBy",
        text: "Locked By",
        style: { textAlign: "left" },
      },
      {
        dataField: "case_ids",
        text: " Case IDs",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="left"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "30vw" }} id="popover-contained">
                  <Popover.Content>{row.case_ids}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.case_ids.length <= 25
                  ? row.case_ids
                  : row.case_ids.substr(0, 25) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row.case_ids ? _popOver : "";
        },
        
      },
      {
        dataField: "date_record_received",
        text: "Date Record Received",
        formatter: (cellContent, row) => {
          return row.date_record_received
            ? ddmmmyyyyFormat(row.date_record_received)
            : "";
        }
      },
      {
        dataField: "date_article_received",
        text: "Date Article Received",
        formatter: (cellContent, row) => {
          return row.date_article_received
            ? ddmmmyyyyFormat(row.date_article_received)
            : "";
        },
      },
      {
        dataField: "locked_by",
        text: "Locked By"
      },
      {
        dataField: "locked_at",
        text: "Locked At"
      },
      {
        dataField: "date_translation_received",
        text: "Date Translation Received",
        formatter: (cellContent, row) => {
          return row.date_translation_received
            ? ddmmmyyyyFormat(row.date_translation_received)
            : "";
        },
      },
      {
        dataField: "date_closed",
        text: "Date Closed",
        formatter: (cellContent, row) => {
          return row.date_closed ? ddmmmyyyyFormat(row.date_closed) : "";
        },
      },
      {
        dataField: "date_abstract_reviewed",
        text: "Date Record Reviewed",
        formatter: (cellContent, row) => {
          return row.date_abstract_reviewed
            ? ddmmmyyyyFormat(row.date_abstract_reviewed)
            : "";
        },
      },
      {
        dataField: "date_article_ordered",
        text: "Date Article Ordered",
        formatter: (cellContent, row) => {
          return row.date_article_ordered
            ? ddmmmyyyyFormat(row.date_article_ordered)
            : "";
        },
      },
      {
        dataField: "date_article_ordered2",
        text: "Date Article Ordered2",
        formatter: (cellContent, row) => {
          return row.date_article_ordered2
            ? ddmmmyyyyFormat(row.date_article_ordered2)
            : "";
        },
      },
      {
        dataField: "date_translation_requested",
        text: "Date Translation Requested",
        formatter: (cellContent, row) => {
          return row.date_translation_requested
            ? ddmmmyyyyFormat(row.date_translation_requested)
            : "";
        },
      },
      {
        dataField: "date_article_reviewed",
        text: "Date Article Reviewed",
        formatter: (cellContent, row) => {
          return row.date_article_reviewed
            ? ddmmmyyyyFormat(row.date_article_reviewed)
            : "";
        },
      },
      {
        dataField: "date_abstract_valid",
        text: "Date Abstract Valid",
        formatter: (cellContent, row) => {
          return row.date_abstract_valid
            ? ddmmmyyyyFormat(row.date_abstract_valid)
            : "";
        },
      },
      {
        dataField: "date_article_valid",
        text: "Date Article Valid",
        formatter: (cellContent, row) => {
          return row.date_article_valid
            ? ddmmmyyyyFormat(row.date_article_valid)
            : "";
        },
      },
      {
        dataField: "date_translation_valid",
        text: "Date Translation Valid",
        formatter: (cellContent, row) => {
          return row.date_translation_valid
            ? ddmmmyyyyFormat(row.date_translation_valid)
            : "";
        },
      },
      {
        dataField: "date_flw_up_received",
        text: "Date Follow-Up Received",
        sort: true,
        formatter: (cellContent, row) => {
          return row.date_flw_up_received
            ? ddmmmyyyyFormat(row.date_flw_up_received)
            : "";
        },
      },
      {
        dataField: "lock_by_date",
        text: "Lock By Date",
        formatter: (cellContent, row) => {
          return row.lock_by_date ? ddmmmyyyyFormat(row.lock_by_date) : "";
        },
      },
    ];
    let colMapper = {}
    mappers.forEach(field => {
      colMapper[field.dataField] = {
        text: field.text,
        formatter: (cellContent, row) => (field.formatter ? field.formatter(cellContent, row) : cellContent)
      }
    });
    let auditColumns = [
      {
        dataField: "abstractAuditId",
        sort: true,
        hidden: true,
      },
      {
        dataField: "updatedAt",
        text: "Date/Time",
        sort: true,
        headerClasses: "width-50",
        formatter: (cellContent, row) => {
          return row && row.updatedAt ? ddmmmyyyyFormat(row.updatedAt, true) : "";
        },
      },
      {
        dataField: "updatedBy",
        text: "System Id",
        headerClasses: "width-50",
        sort: true,
        formatter: (cellContent, row) => {
          return row && row.updatedBy ? row.updatedBy : row && row.createdBy ? row.createdBy : ""
        }
      },
      {
        dataField: "action",
        text: "Operation",
        headerClasses: "width-50",
        sort: true,
      },
      {
        dataField: "field",
        text: "Field Name",
        headerClasses: "width-50",
        sort: true,
        formatter: (cellContent, row) => {
          return row && colMapper[row.field] ? colMapper[row.field].text : row.field;
        }
      },
      {
        dataField: "oldValue",
        text: "Old Value",
        headerClasses: "width-160",
        sort: true,
        formatter: (cellContent, row) => {
          if (!row) return "";
          return row.oldValue === "null" || !colMapper[row.field] ? row.oldValue : colMapper[row.field].formatter(row.oldValue, { [row.field]: row.oldValue });
        }
      },
      {
        dataField: "newValue",
        headerClasses: "width-160",
        text: "New Value",
        sort: true,
        formatter: (cellContent, row) => {
          if (!row) return "";
          return row.newValue === "null" || !colMapper[row.field] ? row.newValue : colMapper[row.field].formatter(row.newValue, { [row.field]: row.newValue });
        }
      },
    ];
    return (
      <>
        {isLoading && (
          <div className="loader">
            <FaSpinner />
          </div>
        )}
        <div className="CommonWrap">
          <Container fluid>
            <div className="headerpart headerpartCustom">
              <Row>
                <Col sm={9}>
                  {" "}
                  <h1>Audit Trail</h1>
                </Col>
                <Col className="text-right mt-3 col">
                  <Button
                    variant="primary"
                    type="submit"
                    className="mr-2 btn btn-primary"
                    onClick={this.handleBackFunction}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    className="mr-2 btn btn-primary"
                    onClick={() => { this.exportFile(auditData, colMapper) }}
                  >
                    Print All
                        </Button>
                </Col>
              </Row>
            </div>
            <Row className="mt-5 abstract-datatable">
              <Col sm={12}>
                <DataTable
                  keyField="abstractAuditId"
                  defaultSortField="abstractAuditId"
                  data={auditData}
                  columns={auditColumns}
                  csvName={false}
                  showSearch={true}
                  showPagination={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="text-right mt-3">
                <Button
                  variant="primary"
                  type="submit"
                  className="mr-2 btn btn-primary"
                  onClick={this.handleBackFunction}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    productData: state.abstractDataReducer.productData,
    countryData: state.abstractDataReducer.countryData,
    statusData: state.abstractDataReducer.statusData,
    explanationData: state.abstractDataReducer.explanationData
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadAllProduct,
      loadAllCountry,
      loadAllExplanation,
      loadAllStatus,
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Audit));